import React, { FC } from 'react';

import { IIconType } from './types';

export const IconCheckmark: FC<IIconType> = ({ size = 24 }) => {
    return (
        <svg
            width="10"
            height="8"
            viewBox="0 0 10 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1 4L4 7L9 1"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
